import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  assignmentcontainerform: {
    paddingTop: 20,
    paddingLeft: 20,
    paddingBottom: 20,
    [theme.breakpoints.down("sm")]: {
      paddingTop: 10,
      paddingLeft: 1,
      paddingBottom: 10
    }
  },
  quizcontainer: {
    padding: 10,
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 10,
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
    width: "66%",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  wrapper: {
    width: "20%",
    margin: "auto",
    marginTop: 10,
    [theme.breakpoints.down("md")]: {
      width: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  questioncontainer: {
    padding: 10,
    borderRadius: 10,
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
    width: "66%",
    marginTop: 20,
    [theme.breakpoints.down("md")]: {
      width: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  title: {
    color: "#98A2B3",
    fontSize: 14,
    marginBottom: 3
  },
  subtitle: {
    color: "#40444B",
    fontSize: 14,
    fontWeight: 500
  },
  detailstext: {
    textAlign: "left"
  },
  question: {
    borderRadius: "8px",
    border: "1px solid #E4E7EC",
    background: "#F9F9F9",
    padding: "16px",
    marginTop: "16px"
  },
  divider: {
    paddingTop: 5,
    paddingBottom: 5
  },
  inputmargin: {
    paddingTop: 10
  },
  camera: {
    color: "rgb(96, 168, 255)",
    width: "30px !important",
    fontSize: "40px !important"
  },
  profilepicker: {
    opacity: 0,
    width: "40px",
    height: "40px",
    cursor: "pointer",
    position: "absolute",
    paddingTop: "10px !important"
  },
  nocenteritem: {
    textAlign: "left"
  },
  createAssignmentContent: {
    padding: "15px 20px",
    border: "1px solid #E4E7EC",
    borderRadius: "15px",
    width: "80%",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  correctlabel: {
    marginTop: 3
  },
  correctcontainer: {
    // color: "#667185",
    fontSize: 13,
    display: "flex",
    alignItems: "center",
    color: theme.palette.primary.main,
    fontWeight: 500
  },
  questionfooter: {
    display: "flex",
    justifyContent: "right",
    marginTop: "8px",
    flexDirection: "row",
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  editquestionfooter: {
    display: "flex",
    marginLeft: "auto",
    marginTop: "2px",
    marginBottom: "28px",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  btnwrapper: {
    width: "50%",
    marginTop: "30px",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    gap: "16px",
    "@media (max-width: 600px)": {
      flexWrap: "wrap",
      width: "100%"
    }
  },
  pointsInput: {
    width: "180px",
    height: "30px",
    boxSizing: "border-box",
    paddingLeft: "10px",
    paddingRight: "10px",
    border: "1px solid hsl(0, 0%, 80%)",
    marginTop: "4px",
    borderRadius: "6px",
    backgroundColor: "white",
    color: "#667185",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  assignmentsection: {
    background: "#F9F9F9",
    width: "100%",
    borderRadius: "8px",
    padding: "31px",
    border: "1px solid #E4E7EC",
    marginBottom: "16px",
    "@media (max-width: 430px)": {
      padding: "14px"
    }
  },
  quelabel: {
    textAlign: "left",
    display: "flex",
    color: "#545962",
    fontSize: "14px",
    fontWeight: "700"
  },
  timeleft: {
    "& h2": {
      marginBlock: "5px",
      fontSize: "14px"
    }
  },
  quesaction: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  addque: {
    justifyContent: "flex-end",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer",
    color: theme.palette.primary.main,
    "& p": {
      marginBlock: "0px",
      fontWeight: "700"
    }
  },
  addoption: {
    justifyContent: "flex-start",
    marginTop: "10px",
    display: "flex",
    maxWidth: "200px",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer",
    color: theme.palette.primary.main,
    "& p": {
      marginBlock: "0px",
      fontWeight: "400",
      fontSize: "14px"
    }
  },
  displaynone: {
    display: "none"
  },
  textandimgmain: {
    width: "100%",
    marginTop: 4
  },
  quesdisplay: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    width: "100%",
    height: "80px",
    overflow: "hidden",
    marginBottom: "24px",
    "& img": {
      height: "100%",
      width: "auto",
      objectFit: "contain",
      "@media (max-width: 430px)": {
        height: "30px"
      }
    }
  },
  optiondisplay: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    width: "100%",
    height: "40px",
    overflow: "hidden",
    "& img": {
      height: "100%",
      width: "auto",
      objectFit: "contain",
      "@media (max-width: 430px)": {
        height: "30px"
      }
    }
  },
  queimg: {
    position: "absolute",
    top: "15px",
    right: "15px",
    cursor: "pointer"
  },
  enterque: {
    color: "#101928",
    display: "flex",
    justifyContent: "left",
    marginBlock: "5px 0px",
    fontSize: "14px",
    fontWeight: "500",
    textAlign: "left"
  },
  textandimg: {
    position: "relative",
    marginTop: "2px",
    borderRadius: "6px",
    border: "1px solid hsl(0, 0%, 80%)",
    backgroundColor: "white",
    "& input": {
      width: "100%",
      height: "46px",
      boxSizing: "border-box",
      background: "none",
      border: "0px",
      paddingLeft: "10px",
      paddingRight: "35px",
      color: "#667185"
    }
  },
  preiewcont: {
    "& img": {
      marginLeft: "10px",
      maxWidth: "300px",
      height: "200px",
      marginBottom: "20px"
    },
    "@media (max-width: 500px)": {
      "& img": {
        maxWidth: "150px",
        height: "100px"
      }
    }
  },
  preiewoptioncont: {
    "& img": {
      marginLeft: "10px",
      maxWidth: "200px",
      height: "100px",
      marginBottom: "20px"
    },
    "@media (max-width: 500px)": {
      "& img": {
        maxWidth: "120px",
        height: "100px"
      }
    }
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center"
  },
  verticalline: {
    paddingLeft: 15,
    paddingBottom: 5,
    textAlign: "left"
  },
  logdetails: {
    "& h5": {
      fontSize: "11.33px",
      color: "#6C737F",
      marginBlock: "0px",
      fontWeight: "700",
      textAlign: "left"
    },
    "& p": {
      marginBlock: "0px",
      fontSize: "9.71px",
      color: "#6C737F",
      textAlign: "left"
    }
  },
  logtitle: {
    "& h4": {
      fontSize: "16px",
      color: "#6C737F",
      marginBlock: "0px 16px",
      fontWeight: "700",
      textAlign: "left"
    }
  },
  rightcont: {
    "@media (min-with: 900px) and (max-width: 1199px)": {
      display: "flex",
      gap: "20px"
    },
    "@media (max-width: 600px)": {
      display: "none"
    }
  },
  mobilescont: {
    position: "relative",
    display: "none",
    width: "95%",
    margin: "auto",
    paddingInline: "14px",
    "@media (max-width: 600px)": {
      display: "block",
      position: "fixed",
      bottom: "10px"
    }
  },
  desktopbtns: {
    display: "block",
    "@media (max-width: 600px)": {
      display: "none"
    }
  },
  mobiles: {
    position: "relative"

  },
  // For Get Student Test UI
  noexamcont: {
    margin: "20px auto"
  },
  noexamimg: {
    marginTop: "60px",
    margin: "auto",
    maxWidth: "155px"
  },
  nocodeheader: {
    fontWeight: 500,
    fontSize: "14px",
    textAlign: "center",
    color: "#000000",
    marginBlock: "0px"
  },
  nocodesentence: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#475367",
    textAlign: "center",
    marginBlock: "0px"
  },
  cardcont: {
    width: "100%",
    border: "1px solid #E4E7EC",
    borderRadius: "9px",
    padding: 16,
    "& h3": {
      fontSize: "24px",
      fontWeight: 700,
      marginBlock: "0px",
      color: "#101928"
    },
    "& p": {
      fontSize: 16,
      fontWeight: "400",
      marginBlock: "0px",
      color: "#101928"
    },
    "& h2": {
      fontSize: "36px",
      fontWeight: 700,
      marginBlock: "0px",
      color: "#101928"
    }
  },
  durationcont: {
    padding: "8px",
    backgroundColor: "#E6F0FF",
    borderRadius: "4px",
    "& p": {
      color: theme.palette.primary.main,
      marginBlock: "0px",
      fontWeight: "700 !important",
      fontSize: "14px !important"
    }
  },
  itembottom: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    marginTop: "16px",
    padding: "8px",
    borderRadius: "8px",
    border: "1px solid #0065FF"
  },
  examlink: {
    textDecoration: "none",
    fontWeight: "500",
    fontSize: "20px",
    color: theme.palette.primary.main
  },
  questioncont: {
    padding: "16px",
    height: "150px",
    border: "1px solid #F0F2F5 !important",
    borderRadius: "8px",
    overflowY: "auto",
    boxShadow: "0px 0px 3px 0px #00000040",
    marginTop: "23px",
    "& h5": {
      color: "#6C737F",
      fontSize: "18px",
      fontWeight: "400",
      marginBlock: "0px 14px"
    },
    "& p": {
      color: "#6C737F",
      fontSize: "16px",
      fontWeight: "400",
      padding: "4px 8px",
      borderRadius: "9px",
      border: "1px solid #00000033",
      marginBlock: "0px 8px",
      cursor: "pointer"
    },
    "& p:active": {
      backgroundColor: "#F5F6F7"
    },
    "@media (max-width: 900px)": {
      marginTop: "0px"
    },
    "@media (max-width: 530px)": {
      padding: "12px",
      marginTop: "20px"
    }
  },
  progressbar: {
    marginBlock: "20px",
    "@media (min-width: 900px)": {
      display: "none"
    },
    "@media (max-width: 600px)": {
      marginTop: "0px 8px"
    }
  },
  timercont: {
    padding: "26px",
    border: "1px solid #F0F2F5",
    borderRadius: "8px",
    boxShadow: "0px 0px 3px 0px #00000040",
    "& h5": {
      color: "#6C737F",
      fontSize: "18px",
      fontWeight: "400",
      marginBlock: "0px 23px"
    },
    "@media (max-width: 900px)": {
      display: "none"
    },
    "@media (min-with: 900px) and (max-width: 1199px)": {
      display: "block"
    }
  },
  testcont: {
    marginInline: "30px"
  },
  submitbtn: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  mainpage: {
    maxWidth: "1280px",
    margin: "auto",
    height: "calc(100vh - 200px)",
    overflowY: "auto",
    marginTop: "4%",
    "@media (max-width: 600px)": {
      height: "calc(100vh - 50px)"
    }
  },
  instructioncont: {
    marginBottom: "24px",
    "& p": {
      marginBlock: "3px !important"
    },
    "@media (max-width: 600px)": {
      "& p": {
        fontSize: "14px"
      }
    }
  },
  enroldetails: {
    "& p": {
      marginBlock: "0px"
    }
  },
  subtitles: {
    fontWeight: 700,
    fontSize: 16,
    marginBlock: "0px"
  },
  btns: {
    display: "flex",
    marginTop: "24px",
    gap: "16px",
    "@media (max-width: 600px)": {
      flexDirection: "column"
    }
  },
  questionmaincont: {
    padding: "6px",
    border: "1px solid rgb(242, 242, 242) !important",
    borderRadius: "8px",
    height: "51vh",
    // boxShadow: "0px 0px 3px 0px #00000040",
    marginBottom: "24px",
    "@media (max-width: 600px)": {
      border: "1px solid rgb(125, 125, 125) 110, 112) !important",
      height: "45vh"
    }
  },
  getcont: {
    textAlign: "left",
    backgroundColor: "#F7F9FC",
    padding: "24px",
    borderRadius: "8px",
    "@media (max-width: 600px)": {
      padding: "12px"
    }
  },
  item: {
    marginTop: "12px",
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.main
    },
    "& p": {
      marginBlock: "0px"
    }
  },
  getstarted: {
    fontSize: "24px",
    fontWeight: "500",
    marginBlock: "0px",
    // cursor: "pointer",
    color: "#000",
    "@media (max-width: 600px)": {
      fontSize: "16px"
    }
  },
  actionIconGroup: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap"
  },
  exportIconBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: "white",
    border: `1.5px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    padding: 0,
    "&:hover": {
      backgroundColor: "#E6F0FF"
    }
  },
  editIconBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: theme.palette.primary.main,
    border: `1.5px solid ${theme.palette.primary.main}`,
    color: "white",
    padding: 0,
    "&:hover": {
      opacity: 0.9
    }
  }
}));
